// Auto-generated from translation.csv; do not edit manually
export const deDE = {
  "accountGuide": {
    "content": "Öffnen Sie ein beliebiges Spiel von Touka, gehen Sie zum Einstellungsmenü im Spiel und binden Sie Ihre E-Mail-Adresse, um von Sonderangeboten zu profitieren!",
    "title": "Wie erstelle ich ein Konto?"
  },
  "bottomNav": {
    "home": "Startseite",
    "myOrders": "Meine Bestellungen"
  },
  "common": {
    "loading": "Laden...",
    "noData": "Keine Daten",
    "server": "Server"
  },
  "footer": {
    "language": "Chinesisch (vereinfacht)",
    "privacyPolicy": "Datenschutzrichtlinie",
    "refundPolicy": "Rückerstattungsrichtlinie",
    "termsOfService": "Nutzungsbedingungen",
    "userSupport": "Benutzersupport",
    "downloadNow": "Jetzt herunterladen!"
  },
  "header": {
    "characterName": "Charaktername",
    "gameServer": "Spielserver",
    "selectGameServer": "Spielregion auswählen",
    "greeting": "Hallo",
    "loginPrompt": "Bitte klicken Sie auf Anmelden",
    "switchServer": "Wechseln",
    "title": "Spiel-Aufladeplattform",
    "logout": "Abmelden"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "Oopsie Croco"
  },
  "history": {
    "backToGameZone": "Zurück zum Spiel-Shop",
    "allGames": "Alle Spiele",
    "empty": "Hier gibt es noch keine Bestellungen～",
    "filter": {
      "all": "Alle",
      "closed": "Geschlossen",
      "completed": "Abgeschlossen",
      "inProgress": "In Bearbeitung",
      "pendingDelivery": "Ausstehender Versand "
    },
    "orderTime": "Bestellzeit:",
    "pendingAutoCancelPrefix": "Die Bestellung wird in",
    "pendingAutoCancelSuffix": "automatisch storniert",
    "cancelOrder": "Bestellung stornieren",
    "payOrder": "Bezahlen",
    "cancelOrderConfirmTitle": "Bestellung stornieren?",
    "cancelOrderConfirmPrimary": "Bestätigen",
    "cancelOrderDismiss": "Vorerst nicht",
    "status": {
      "cancelled": "Storniert ",
      "completed": "Transaktion abgeschlossen ",
      "paid": "Bezahlt ",
      "pending": "Ausstehende Zahlung",
      "shipped": "Versandt"
    }
  },
  "home": {
    "selectGame": "Wählen Sie das Spiel, das Sie aufladen möchten",
    "selectGameParts": {
      "prefix": "Wählen Sie das Spiel, das Sie ",
      "keyword": "aufladen",
      "suffix": " möchten"
    },
    "noRoleAccount": "Sie haben in diesem Spiel noch keinen Charakter. Bitte erstellen Sie zuerst einen Charakter im Spiel, bevor Sie kaufen.",
    "noRoleRefreshPrefix": "Konto bereits erstellt? Tippen Sie auf ",
    "noRoleRefreshAction": "Aktualisieren",
    "noRoleRefreshing": "Wird aktualisiert…",
    "noRoleRefreshNotFound": "Keine Charakterinformationen gefunden",
    "noRoleRefreshFailed": "Aktualisierung fehlgeschlagen. Bitte versuchen Sie es später erneut."
  },
  "login": {
    "agreeTerms": {
      "and": "und",
      "prefix": "Ich habe gelesen und stimme zu",
      "privacy": "Datenschutzrichtlinie",
      "terms": "Nutzungsbedingungen "
    },
    "cancel": "Abbrechen ",
    "bindGameGuide": "Hinweis zur Spielverknüpfung",
    "bindGameGuideContent": "Öffnen Sie ein beliebiges Touka-Spiel,\ngehen Sie zu den Spieleinstellungen,\nverknüpfen Sie Ihre E-Mail,\nund profitieren Sie von Sonderangeboten im Shop!",
    "captchaPlaceholder": "Bestätigungscode ",
    "invalidCaptcha": "Bitte geben Sie einen 4-stelligen Bestätigungscode ein",
    "email": "E-Mail ",
    "emailNotBound": "Abfrage nicht erfolgreich, bitte geben Sie die im Spiel registrierte E-Mail-Adresse ein~",
    "emailPlaceholder": "Bitte geben Sie Ihre E-Mail-Adresse ein ",
    "keepLogin": "Angemeldet bleiben für 15 Tage ",
    "loading": "Anmeldung läuft... ",
    "loginToStore": "Bei Touka Store anmelden ",
    "noAccount": "Noch kein Konto? ",
    "password": "Passwort ",
    "passwordPlaceholder": "Bitte Passwort eingeben ",
    "submit": "Anmelden",
    "title": "Anmelden",
    "invalidEmail": "Bitte geben Sie eine gültige E-Mail-Adresse ein"
  },
  "logout": {
    "cancel": "Abbrechen",
    "confirm": "Bestätigen",
    "dontRemind": "Nicht mehr erinnern",
    "messageLine1": "Nach Abmeldung sind innerhalb der letzten 30 Tage alle Geräte von",
    "messageLine2": "Der Anmeldestatus wird ungültig.",
    "title": "Freundlicher Hinweis"
  },
  "menu": {
    "contactSupport": "Kundenservice kontaktieren",
    "gameList": "Spielliste",
    "myOrders": "Meine Bestellungen"
  },
  "paymentSuccess": {
    "account": "Konto:",
    "celebrationTitle": "Kauf erfolgreich",
    "confirm": "Bestätigen",
    "getPaymentInfoFailed": "Fehler beim Abrufen der Zahlungsinformationen",
    "loading": "Wird geladen...",
    "orderDate": "Bestelldatum:",
    "orderId": "Bestellnummer:",
    "paymentMethod": "Zahlungsmethode:",
    "paypal": "PayPal",
    "price": "Preis:",
    "purchaseContent": "Kaufinhalt:",
    "quantity": "Kaufsmenge:",
    "serverAndCharacter": "Server/Charakter:",
    "title": "Danke für Ihren Kauf",
    "total": "Alle:",
    "unionPay": "UnionPay",
    "amountPaid": "Gezahlter Betrag:",
    "closeModal": "Schließen"
  },
  "productModal": {
    "confirm": "Bestätigen",
    "purchaseDetails": "Kaufdetails",
    "quantity": "Menge:",
    "total": "Alle:",
    "unitPrice": "Stückpreis:"
  },
  "products": {
    "giftPacks": "Paket",
    "diamond": "Diamant",
    "products": "Artikel",
    "vouchers": "Gutschein",
    "toukaCoin": "Touka Coin",
    "toukaCoinBonusTip": "Shoppen Sie im TOUKA Store und erhalten Sie 10 % extra Belohnung!",
    "superValue": "Top-Angebot",
    "limitShort": "Limit",
    "remainingShort": "Restzeit",
    "giftPackLimitType": {
      "lifetime": "Lebenslang",
      "weekly": "Wöchentlich",
      "monthly": "Monatlich"
    },
    "howToUseVouchers": "Wie verwendet man Touka Coin?",
    "voucherGuide": {
      "title": "Wie verwendet man Touka Coin?",
      "step1": "1.Bitte überprüfen Sie die von Ihnen gekauften Touka Coins im Postfach im Spiel.",
      "step2": "2.Sie können die Anzahl Ihrer Touka Coins oben im Tab des In-Game-Shops sehen. Wenn die Anzahl Ihrer Touka Coins die für den Kauf eines Pakets erforderliche Menge erreicht, werden Touka Coins vorrangig für den Kauf verwendet.",
      "backToProducts": "Zur Produktliste zurückkehren"
    }
  },
  "purchaseConfirm": {
    "card": "Kreditkarte/EC-Karte",
    "confirm": "Bestätigen",
    "dontAskAgain": "In den nächsten 30 Tagen nicht mehr fragen",
    "gameServer": "Spielserver",
    "paymentMethods": "Unterstützte Zahlungsmethoden",
    "paypal": "PayPal",
    "title": "Sind Sie sicher, dass Sie mit diesem Konto kaufen möchten?",
    "unionPay": "UnionPay-Karte"
  },
  "serverSelect": {
    "characterLabel": "Charaktername",
    "characterPlaceholder": "Bitte wählen Sie einen Charakter",
    "confirm": "Bestätigen",
    "noResults": "Keine Ergebnisse",
    "serverPlaceholder": "Servername",
    "title": "Spielregion auswählen",
    "title": "Spielserver auswählen"
  },
  "support": {
    "cancel": "Abbrechen",
    "copied": "Kopiert",
    "copy": "Mit einem Klick kopieren",
    "description": "Bitte senden Sie Ihre detaillierten Informationen an die offizielle E-Mail",
    "title": "Kundensupport"
  },
  "verification": {
    "back": "Zurück",
    "enterCode": "Bitte geben Sie den Verifizierungscode ein, um fortzufahren",
    "incorrectCode": "Der Verifizierungscode ist falsch",
    "invalidCode": "Bitte geben Sie den 6-stelligen Verifizierungscode ein",
    "noCode": "Keinen Verifizierungscode erhalten?",
    "sentTo": "Der Verifizierungscode wurde gesendet an",
    "submit": "Absenden",
    "submitting": "Wird gesendet..."
  }
} as const;
